import React from 'react';
import './Speakers.css';

import { Heading, PageTitle, TeamItem } from '../../../components';
import { speakers } from '../../../constants';



const Speakers = () => {

  return (

    <>

      <PageTitle title={'Speakers'} page={'Speakers'} />

      <section className='speakers'>

        {/* Section heading */}
        <Heading title={'Featured Speakers'} subTitle={'Meet Our Speakers'} />

        <div className='box-container'>
          {
            // Map over the speakers array to render each speaker
            speakers.map((item) => {
              return (
                <TeamItem key={item.id} team={item} type="speaker" /> 
              )
            })
          }
        </div>
      </section>

    </>

  )
  
}

export default Speakers;